/**
 * This file tracks events specific to development, such as performance metrics.
 */
import {makeTrackEvent} from './makeTrackEvent';

export const enum DevEventNames {
  MeasureComponentSpan = 'perf-span-measure-component-span', // tracks the time between two points in a component's lifecycle
  PerfSpanEntityPageLoader = 'perf-span-entity-page-loader', // This tracks the amount of time the entity page loader is onscreen
}

export type EntityLoaderEventData = {
  [key: string]: any;
  duration: number;
  spanName: string;
  startTime: number;
  stopTime: number;
};

export const componentSpan = makeTrackEvent<EntityLoaderEventData>(
  DevEventNames.MeasureComponentSpan,
  {
    sampleRate: 0.75, // heavy sampling as I need a baseline quickly to measure against
  }
);
export const entityPageLoad = makeTrackEvent<EntityLoaderEventData>(
  DevEventNames.PerfSpanEntityPageLoader,
  {
    sampleRate: 0.125,
  }
);
